var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('router-link',{staticClass:"internal-link",attrs:{"to":_vm.link({ name: _vm.name, query: _vm.query })}},[_vm._t("default")],2):_c('span',{staticClass:"internal-link"},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23dc3966","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InternalLink.vue
// module id = null
// module chunks = 